import { render, staticRenderFns } from "./OsdiCloseButton.vue?vue&type=template&id=5748dc1c&scoped=true&"
import script from "./OsdiCloseButton.vue?vue&type=script&lang=ts&"
export * from "./OsdiCloseButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5748dc1c",
  null
  
)

export default component.exports